import styled from 'styled-components';

export const Wrapper = styled.div`
    
`;

export const APIkeyWrapper = styled.div`
    .content {
      padding: 1rem;
    }
    .d-flex {
      display: flex;
    }
    .content-align {
      margin-top: 20px;
      justify-content: space-between;
    }
    .text-center {
      text-align: center;
      margin: 1rem;
    }
    .key-description {
      color: #000000;
      max-width: 46rem;
      margin: 1rem auto;
    }
    .key-link {
      color: #0000FF;
      cursor: pointer;
      text-decoration: underline;
    }
    .key-title {
      font-size: 19px;
      font-weight: bold;
      margin: 8px;
    }
    .key-icon {
      height: 7rem;
      width: 7rem;
    }
    .table-align {
      margin-top: 20px;
      .name-section {
        display: flex;
        align-items: center;
        cursor: pointer;
        .anticon-caret-down,
        .anticon-caret-up {
          margin-left: 10px;
          margin-top: 3px;
        }
        .master-key-icon {
          margin-right: 6px;
          width: 15px;
        }
      }
    }
    .ant-select {
      width: 150px;
      margin-left: 18px;
    }
    .ant-select-selection--single {
      position: relative;
      height: 32px;
      cursor: pointer;
    }
    .btn-align {
      margin-left: 10px;
    }
    .inner-content {
        background-color: #212121;
        padding: 2rem 3rem;
        margin: 10px 20px;
        .header {
          font-size: 18px;
          font-weight: bold;
        }
    }
    .details-wrapper {
      background-color: #212121;
      padding: 1rem;
      display: flex;
      .section-wrapper {
        margin-left: 2rem;
        width: 100%;
        .small-txt {
          font-size: 12px;
          font-weight: bold;
        }
        .small-txt-info {
          font-size: 12px;
          color: #A8A8B1;
        }
        .access-wrapper {
          display: flex;
          margin-top: 20px;
          .w-30 {
            width: 32%;
            padding: 0 10px;
          }
          .disable {
            opacity: 0.5;
            pointer-events: none;
          }
          .ant-checkbox-inner {
              background-color: #A8A8B1;
              color: #A8A8B1;
            }
          .ant-checkbox-checked {
            .ant-checkbox-inner {
              background-color: #ffffff;
            }
            .ant-checkbox-inner::after {
              border-color: #000 !important;
            }
            .span {
            color: #fff;
          }
          }
          .ant-checkbox + span {
            color: #fff;
          }
          .ant-checkbox-wrapper-checked,
          .ant-checkbox-checked,
          .ant-radio-wrapper-checked .radio-text,
          .ant-checkbox-wrapper .active {
            color: #fff;
          }
          .ant-checkbox-group-item,
          .ant-checkbox-wrapper,
          .ant-radio-wrapper .radio-text {
            font-size: 12px;
          }
          .ant-radio-wrapper .ant-radio-inner {
            border-color: #000;
          }
          .ant-radio-wrapper .ant-radio-checked .ant-radio-inner::after {
            background-color: #000;
          }
          .api-key {
            .ant-input-group-addon,
            .ant-input::placeholder {
              font-size: 12px;
            }
          }
          .onlyTrustedIp {
            margin-top : 5px
          }
          .ipInput-wrapper {
            margin-top: 1rem;
            color: #A8A8B1;
            .ant-input {
              color: #000;
              font-size: 12px;
            }
            .ant-tag.edit-tag {
              background-color: #0000FF1A;
              border-radius: 15px;
              margin-bottom: 10px;
            }
            .ex-text {
              font-size: 12px;
              margin: 5px;
            }
            .err-text {
              font-size: 12px;
              color: red;
              margin-top: 6px;
            }
          }
          .ant-checkbox-group {
            display: flex;
            flex-direction: column;
            .ant-checkbox-group-item {
              padding: 4px 0;
            }
          }
          .ant-radio-group {
            .ant-radio-wrapper {
              display: flex;
              align-items: center;
            }
          }
        }
        .mt-1 {
          margin-top: 1rem;
        }
        .ant-btn {
          height: 20px;
          font-size: 12px;
          text-align: center;
          margin-top: 2rem;
          padding: 0 2rem;
        }
        .apiKey-wrapper {
          .ant-input,
          .ant-input-group-addon {
            font-size: 12px;
          }
        }
      }
      .section-1 {
        display: flex;
        .secretKey-wrapper {
          margin-left: 4rem;
          .ant-input {
            font-size: 12px;
          }
        }
        .disabled-field {
          .ant-input-group-wrapper{
            pointer-events: none;
            opacity: 0.5;
          }
        }
      }
    }
    .api-key {
      .ant-input {
        color: #5985ff;
        border-right: none;
      }
      .ant-input-group-addon {
        color: #5985ff;
        cursor: pointer;
        border-color: #d9d9d9;
      }
      /* .ant-input:hover {
        border-color: #d9d9d9;
      }
      .ant-input:focus {
        border-color: #d9d9d9;
        box-shadow: unset;
      } */
    }
    .center-spin {
      margin-left:48%;
      margin-top:20px;
    }
    @media(max-width: 960px) {
      .table-align {
         overflow-x: scroll;
      }
    }
    @media(max-width: 360px) {
      .ant-select {
         width: 100%;
         margin-left: 18px;
      }
    }
`;

export const RevokeKeyWrapper = styled.div`
  padding: 1.5rem 2rem;
  &.terminate-wrapper {
      background-color: #F83E1B;
      border-radius: 4px;
      color: #ffffff;
      padding: 1.5rem 2rem;
  }
  color: #fff;
  .btn-wrapper {
    display: flex;
    justify-content: space-between;
    margin: 40px 0 15px 0;
    .ant-btn {
      width: 220px;
      height: 40px;
      background-color: #4C00FF;
    }
    .close-btn {
        background-color: #ffffff;
        border-color: #ffffff;
        color: #000000;
    }
    .proceed-btn {
        background-color: #000000;
        border-color: #000000;
        color: #ffffff;
    }
  }
  .step-1-container {
    .img-wrapper{
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .revoke-key-img {
      width: 150px;
    }
    .revoke-masterKey-img {
      width: 100px;
      margin-bottom: 2rem;
    }
    .header-txt {
      font-size: 19px;
      font-weight: bold;
      text-align: center;
    }
    .info-txt {
      text-align: center;
    }
  }
  .step-2-container, .step-3-container {
    .header-txt {
      font-size: 19px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .subTitle {
      font-weight: bold;
    }
    .mt-2 {
      margin-top: 25px;
    }
  }
  .step-2-container {
    .warning-section {
      display: flex;
      align-items: center;
      margin-top: 1.5rem;
      svg {
        fill: #FF0000;
        font-size: 18px;
        margin-right: 10px;
      }
      .warning-txt {
        color: #FF0000;
      }
    }
  }
  .step-3-container {
    .inner-content {
      margin-top: 40px;
      .ant-input {
        border-radius: 0;
        border-color: #707070;
        background-color: #212121;
        margin-top: 8px;
      }
    }
    .ant-btn-primary[disabled] {
      background-color: #42454D !important;
    }
  }
  .input-wrapper {
    		padding: 22px;
			width: 100%;
			.sub-header {
				color: #fff;
				font-size: 18px;
			}
			.ant-btn {
				height: 50px;
				margin-top: 0.5rem;
			}
			.select-wrapper {
				margin: 5px 0 10px 0;
    			width: 160px;
			}
			.general-content {
				.d-flex {
					display: flex;
    				align-items: center;
				}
				.bold {
					margin-left: 8px;
					font-weight: bold;
					color: #000000;
				}
				.disable-txt {
					margin-left: 23px;
					opacity: 0.5;
    				margin-bottom: 2rem;
				}
				.anticon {
    				font-size: 20px;
					svg {
						fill: #2727ff;
					}
				}
				.errText {
					color: #FF0000;
				}
			}
			.name-input {
    			margin: 30px 0 25px 0;
			}
			.general-wrapper {
    			display: flex;
				.anticon {
					margin: 7px 10px 0px 0px;
					font-size: 26px;
					svg {
    					fill: #2727FF;
					}
				}
			}
			.twoFA-input {
    			margin-bottom: 2rem ;
			}
			.verification-wrapper {
				.d-flex {
					display: flex;
				}
				.anticon {
					font-size: 29px;
					margin-right: 10px;
					svg {
    					fill: #000;
					}
				}
			}
		}
		.warning-wrapper {
			padding: 0px;

			.warning-icon {
				color: #0000FF;
				font-size: 32px;
				margin: 0.25rem 0.75rem 0rem 0rem;
			}
			.warning-text {
				color: #FF0000;
			}
			.ant-btn {
        height: 40px;
				margin-top: 0.5rem;
        width: 100%;
			}
		}
    
		.flex-content {
			display: flex;
		}
    .seperator {
      margin: 0.5rem;
    }
`